import Buildings from "@/roc/building";
import Grid from "@/roc/grid/Grid";
import BuildingType, { getBuildingTypeName } from "@/roc/building/BuildingType";
import Rect from "@/roc/grid/Rect";
const checkIntersectingBuildings = function (rectangles) {
    for (let i = 0; i < rectangles.length - 1; i++) {
        for (let j = i; j < rectangles.length; j++) {
            if (i !== j) {
                if (rectangles[i].intersects(rectangles[j])) {
                    console.log("Intersection failed for" +
                        JSON.stringify(rectangles[i]) +
                        " vs " +
                        JSON.stringify(rectangles[j]));
                    return true;
                }
            }
        }
    }
    return false;
};
const checkBuildingCounts = function (idToCountMap, idToBuildingMap) {
    for (const i in idToCountMap) {
        const template = idToBuildingMap[i];
        switch (template.type) {
            case BuildingType.COLLECTABLE:
            case BuildingType.EVENT:
                if (idToCountMap[i] > 1) {
                    throw Error("Too many buildings of type: " + getBuildingTypeName(template.type));
                }
                break;
            case BuildingType.HOME:
            case BuildingType.FARM:
            case BuildingType.CULTURE:
            case BuildingType.BARRACKS:
            case BuildingType.WORKSHOP_1:
            case BuildingType.WORKSHOP_2:
            case BuildingType.WORKSHOP_3:
                // if (template.maxCount[era] > 0 && idToCountMap[i] > template.maxCount[era]) {
                //   throw Error('Too many buildings of type: ' + BuildingType.getName(template.type));
                // }
                break;
            default:
                break;
        }
    }
};
const validateBuildingPlacements = function (buildings, era) {
    if (buildings.length === 1) {
        return;
    }
    const idToBuildingMap = {};
    let hasCityHall = false;
    for (let i = 0; i < Buildings.length; i++) {
        idToBuildingMap[Buildings[i].id] = Buildings[i];
        if (BuildingType.CITY_HALL === Buildings[i].type) {
            hasCityHall = true;
        }
    }
    if (!hasCityHall) {
        throw Error("Missing city hall.");
    }
    const rectangles = [];
    const idToCountMap = {};
    for (let i = 0; i < buildings.length; i++) {
        const template = idToBuildingMap[buildings[i].id];
        if (idToCountMap[buildings[i].id] === undefined) {
            idToCountMap[buildings[i].id] = 0;
        }
        idToCountMap[buildings[i].id]++;
        rectangles.push(new Rect(buildings[i].tileX * Grid.CELL_SIZE, buildings[i].tileY * Grid.CELL_SIZE, (buildings[i].rotate ? template.height : template.width) * Grid.CELL_SIZE, (buildings[i].rotate ? template.width : template.height) * Grid.CELL_SIZE));
    }
    if (checkIntersectingBuildings(rectangles)) {
        throw Error("Intersection check failed");
    }
    checkBuildingCounts(idToCountMap, idToBuildingMap);
};
export default validateBuildingPlacements;
